import { FC, useState } from 'react';
import { CardElement } from '@stripe/react-stripe-js';
import { CouponModal } from './CouponModal';

interface PaymentInfoProps {
  code: string;
  onCouponApplied: (code: string, newPrice: number, newMonthlyPrice: number) => void;
}

export const PaymentInfo: FC<PaymentInfoProps> = ({ code, onCouponApplied }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="flex flex-col gap-4 flex-1">
      <h3 className="[font-size:var(--fs-l1)]! [font-family:var(--font-montserrat)]! text-(--neutral-black-NB1000)! m-0!">
        Card Info
      </h3>

      <div className="relative flex items-center justify-between gap-4 w-full">
        <div className="flex-1 border-2! border-(--neutral-white-NW800)! rounded-xl! p-4 outline-none">
          <CardElement
            options={{
              hidePostalCode: true,
              style: {
                base: {
                  fontSize: '18px',
                  color: '#151C1E',
                  fontFamily: 'Montserrat, sans-serif',
                  '::placeholder': {
                    color: '#8A8A8A',
                  },
                },
                invalid: {
                  color: '#D70000',
                },
              },
            }}
          />
        </div>

        <div className="absolute -bottom-5 right-1">
          <button
            type="button"
            onClick={() => setIsOpen(true)}
            className="text-(--primary-O900)! text-[10px]! font-semibold cursor-pointer underline"
          >
            Code
          </button>
        </div>
      </div>

      <CouponModal
        isOpen={isOpen}
        initialValue={code}
        onClose={() => setIsOpen(false)}
        onApplied={onCouponApplied}
      />
    </div>
  );
};
